import { useEffect } from 'react'
import { domainConfigs } from '../config/domains'

export function useTitle (title) {
  useEffect(() => {
    const currentConfig = domainConfigs.find(config => window.location.hostname.includes(config.domain))
    const baseTitle = currentConfig ? currentConfig.title : 'Zaub Sales Technology'

    document.title = `${title ? title + ' | ' : ''} ${baseTitle}`
  }, [title])
}
